"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserUtilsService = void 0;
var store_1 = require("store");
var localStorage_1 = __importDefault(require("store/storages/localStorage"));
var sessionStorage_1 = __importDefault(require("store/storages/sessionStorage"));
var object_utils_1 = require("@techsee/techsee-common/lib/core/object-utils");
var BrowserUtilsService = /** @class */ (function () {
    function BrowserUtilsService(window) {
        this._window = window;
        object_utils_1.defineNonEnumerable(this, '_window', window);
        this._localStorage = store_1.createStore([localStorage_1.default]);
        this._sessionStorage = store_1.createStore([sessionStorage_1.default]);
        this.isLocalStorageSupported = this.isLocalStorageAvailable();
    }
    BrowserUtilsService.prototype.getParamValue = function (param) {
        var query = this._window.location.search.match(new RegExp('[?&]' + param + '=([^&#]*)'));
        return query && query[1] ? query[1] : undefined;
    };
    BrowserUtilsService.prototype.getHashValue = function (param) {
        var hash = this._window.location.hash.substr(1);
        var result = hash.split('&').reduce(function (result, item) {
            var parts = item.split('=');
            result[parts[0]] = parts[1];
            return result;
        }, {});
        return result[param];
    };
    BrowserUtilsService.prototype.getCurrentOrigin = function () {
        if (this._window.location.origin) {
            return this._window.location.origin;
        }
        var port = this._window.location.port ? ':' + this._window.location.port : '';
        return this._window.location.protocol + "//" + this._window.location.hostname + port;
    };
    BrowserUtilsService.prototype.redirect = function (url) {
        this._window.location.href = url;
    };
    BrowserUtilsService.prototype.openInNewWindow = function (url) {
        this._window.open(url, '_blank');
    };
    BrowserUtilsService.prototype.getCurrentHostName = function () {
        return this._window.location.hostname;
    };
    BrowserUtilsService.prototype.saveToLocalStorage = function (key, data) {
        if (this.isLocalStorageSupported) {
            this._localStorage.set(this.getStorageKey(key), data);
        }
    };
    // eslint-disable-next-line consistent-return
    BrowserUtilsService.prototype.getFromLocalStorage = function (key) {
        if (this.isLocalStorageSupported) {
            return this._localStorage.get(this.getStorageKey(key));
        }
    };
    BrowserUtilsService.prototype.removeFromLocalStorage = function (key) {
        if (this.isLocalStorageSupported) {
            this._localStorage.remove(this.getStorageKey(key));
        }
    };
    BrowserUtilsService.prototype.saveToSessionStorage = function (key, data) {
        if (this.isLocalStorageSupported) {
            this._sessionStorage.set(this.getStorageKey(key), data);
        }
    };
    // eslint-disable-next-line consistent-return
    BrowserUtilsService.prototype.getFromSessionStorage = function (key) {
        if (this.isLocalStorageSupported) {
            return this._sessionStorage.get(this.getStorageKey(key));
        }
    };
    BrowserUtilsService.prototype.removeFromSessionStorage = function (key) {
        if (this.isLocalStorageSupported) {
            this._sessionStorage.remove(this.getStorageKey(key));
        }
    };
    BrowserUtilsService.prototype.getStorageKey = function (key) {
        return "__ts__-" + key;
    };
    BrowserUtilsService.prototype.isLocalStorageAvailable = function () {
        var uid = new Date().toString();
        try {
            this._window.localStorage.setItem(uid, uid);
            var result = this._window.localStorage.getItem(uid) === uid;
            this._window.localStorage.removeItem(uid);
            return !!(result && this._window.localStorage);
        }
        catch (exception) {
            return false;
        }
    };
    return BrowserUtilsService;
}());
exports.BrowserUtilsService = BrowserUtilsService;

//# sourceMappingURL=BrowserUtilsService.js.map
